import { useSearchParams } from 'react-router';
import { TaskListView } from './crm-work.tsx';

const VIEWS = [
  { id: 'today', label: 'Today' }, { id: 'overdue', label: 'Overdue' }, { id: 'upcoming', label: 'Upcoming' },
  { id: 'mine', label: 'Assigned to me' }, { id: 'all', label: 'All' },
] as const;
type View = typeof VIEWS[number]['id'];

export function TasksPage() {
  const [params, setParams] = useSearchParams();
  const view = VIEWS.some((item) => item.id === params.get('view')) ? params.get('view') as View : 'today';
  return <>
    <div className="pagehead"><div><h1>Tasks</h1><p>Follow-ups by due time, owner, priority and record. Due times display in your local time.</p></div></div>
    <div className="views" role="group" aria-label="Task views">{VIEWS.map((item) => <button key={item.id} type="button" className="view" aria-pressed={view === item.id} onClick={() => setParams(item.id === 'today' ? {} : { view: item.id })}>{item.label}</button>)}</div>
    <TaskListView view={view} />
  </>;
}
